// extracted by mini-css-extract-plugin
export var compact = "_mi-2";
export var phoneFrame = "_mi-0";
export var phoneScreen = "_mi-1";